import CardView from './CardView';
import {
  getWorkshopStatus,
  WorkshopStatus,
  FilterWorkshop,
} from 'types/api/responses/workshop';
import LanguageIcon from '@mui/icons-material/Language';
import FilterDashboard from './FilterDashboard';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import CachedIcon from '@mui/icons-material/Cached';
import { apiGet } from 'api/karthus.client';
import { endpoints } from 'api/endpoints';
import { isSuccessResult } from 'utils';
import { ApiData } from 'types/api';
import { useEffect, useState } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { RenderIf } from 'components/Tools/Utils';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { useThunkDispatch } from 'hooks';
import { workshopAll } from 'redux/actions/workshop.actions';
import { HistoryHandler } from 'utils/history.handler';
import { Routes } from 'config/routes';

const fetchWorkshopStatus = async (filter = {}) => {
  try {
    const response = await apiGet<ApiData<WorkshopStatus[]>>(endpoints.workshopStatus, {
      ...filter,
    });

    if (isSuccessResult(response.result)) {
      return response.result.data;
    }
  } catch (error) {
    console.error('Error fetching workshop status:', error);
  }
  return [];
};

export default function Dashboard() {
  const sheet1 = [
    {
      title: 'Total Activos',
      value: 'active',
      icon: LanguageIcon,
    },
    {
      title: 'Clientes sin actualizar',
      value: 'deprecated',
      icon: CachedIcon,
    },
  ];

  const sheet2 = [
    {
      title: 'Total Activos',
      value: 'active',
      icon: LanguageIcon,
    },
    {
      title: 'Total Inactivos',
      value: 'disabled',
      icon: PublicOffIcon,
    },
    {
      title: 'Clientes sin actualizar',
      value: 'deprecated',
      icon: CachedIcon,
    },
  ];
  const showInfoForType = {
    Created: sheet1,
    Profiled: sheet1,
    ProfiledCompleted: sheet1,
    ProfiledIncompleted: sheet1,
    VerifiedIncompleted: sheet1,
    Censused: sheet1,

    TaProfiled: sheet2,
    TaProfiledCompleted: sheet2,
    TaProfiledIncompleted: sheet2,
    TaVerifiedIncompleted: sheet2,
  };
  const [workshopStatus, setWorkshopStatus] = useState<WorkshopStatus[]>([]);

  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState<FilterWorkshop>({
    NameContains: null,
    Status: null,
    ZoneId: null,
    OfficeId: null,
    DaysBefore: null,
    Account: null,
    StartDate: null,
    EndDate: null,
    Active: null,
  });
  const dispatch = useThunkDispatch();

  const handleCardClick = (status: string) => {
    const currentZone = filter.ZoneId || null;
    const currentOffice = filter.OfficeId || null;

    // Aplicar filtro de perfil y navegar a talleres
    dispatch(
      workshopAll({
        params: { page: 1, size: 10 },
        filterN: {
          NameContains: null,
          Status: status,
          ZoneId: currentZone,
          OfficeId: currentOffice,
          DaysBefore: null,
          Account: null,
          StartDate: null,
          EndDate: null,
          Active: null,
        },
      }),
    );
    HistoryHandler.goTo(Routes.workshop + '?bind=true');
  };

  const fetchData = async () => {
    setLoading(true);
    const data = await fetchWorkshopStatus(filter);
    setWorkshopStatus(data);
    setLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, [filter]);

  const styleItemCard = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.3rem',
    justifyContent: 'center',
  };
  return (
    <div style={{ padding: '32px 20px' }}>
      {/* Título con icono */}
      <div
        style={{
          textAlign: 'center',
          marginBottom: '2.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
        }}
      >
        <DashboardIcon style={{ fontSize: '40px', color: '#343c89' }} />
        <h1
          style={{
            margin: 0,
            color: '#343c89',
            fontSize: '2rem',
            fontWeight: 700,
          }}
        >
          Pendientes
        </h1>
      </div>

      {/* Filtros mejorados */}
      <div
        style={{
          marginBottom: '2rem',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            padding: '16px 24px',
            borderRadius: '12px',
            backgroundColor: 'white',
            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
          }}
        >
          <FilterDashboard
            changeZone={function (zoneId: number): void {
              if (zoneId === 0) {
                setFilter({
                  NameContains: null,
                  Status: null,
                  ZoneId: null,
                  OfficeId: null,
                  DaysBefore: null,
                  Account: null,
                  StartDate: null,
                  EndDate: null,
                  Active: null,
                });
                return;
              }
              setFilter((prev) => ({
                ...prev,
                ZoneId: zoneId,
              }));
            }}
            changeOffice={function (officeId: number): void {
              if (officeId === 0) {
                setFilter({
                  NameContains: null,
                  Status: null,
                  ZoneId: null,
                  OfficeId: null,
                  DaysBefore: null,
                  Account: null,
                  StartDate: null,
                  EndDate: null,
                  Active: null,
                });
                return;
              }
              setFilter((prev) => ({
                ...prev,
                OfficeId: officeId.toString(),
              }));
            }}
          />
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '1.5rem',
        }}
      >
        <RenderIf condition={loading}>
          <CircularProgress style={{ margin: '2rem auto' }} />
        </RenderIf>
        <RenderIf condition={!loading}>
          {workshopStatus
            .filter(
              (workshop) =>
                workshop?.status !== 'Migrated' &&
                workshop?.status !== 'TaCreated' &&
                (workshop.active > 0 || workshop.deprecated > 0 || workshop.disabled > 0),
            )
            .sort((a, b) => {
              // Definir el orden de los estados
              const statusOrder: { [key: string]: number } = {
                Created: 0,
                Censused: 1,
                ProfiledIncompleted: 2,
                VerifiedIncompleted: 3,
                TaProfiledIncompleted: 4,
                TaVerifiedIncompleted: 5,
                Profiled: 6,
                TaProfiled: 7,
                ProfiledCompleted: 8,
                TaProfiledCompleted: 9,
              };

              const orderA = statusOrder[a?.status] ?? 999;
              const orderB = statusOrder[b?.status] ?? 999;

              return orderA - orderB;
            })
            .map((workshop) => (
              <CardView
                key={workshop.status}
                title={getWorkshopStatus(workshop.status)?.title ?? ''}
                width="350px"
                color={getWorkshopStatus(workshop.status)?.color ?? 'white'}
                textColor={getWorkshopStatus(workshop.status)?.fix ?? 'black'}
                onClick={() => handleCardClick(workshop.status)}
              >
                {showInfoForType[workshop.status as keyof typeof showInfoForType].map(
                  (item) => (
                    <p key={item.title} style={styleItemCard}>
                      <item.icon /> {item.title}:{' '}
                      <strong style={{ fontSize: '1.2rem' }}>
                        {(workshop as any)[item.value]}
                      </strong>
                    </p>
                  ),
                )}
              </CardView>
            ))}
        </RenderIf>
      </div>
    </div>
  );
}
